module.exports = __webpack_public_path__ + "img/team5.5813dbe7.png";